<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :searchable="false"
      :filters="filters"
      :selectable="false"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader>
        <b-col>
          <b-form-group
            :label="$t('general.user')"
          >
            <v-select-custom
              v-model="userId"
              :options="userOptions"
              :custom-props="{ label: 'fullName' }"
              @open="fetchUsersByRole({ role: 'user' })"
              @search="fetchUsersByRole({ role: 'user', 'search' : $event })"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="$t('general.consultant')"
          >
            <v-select-custom
              v-model="consultantId"
              :options="userOptions"
              :custom-props="{ label: 'fullName' }"
              @open="fetchUsersByRole({ role: 'consultant' })"
              @search="fetchUsersByRole({ role: 'consultant', 'search' : $event })"
            />
          </b-form-group>
        </b-col>
      </template>

      <!-- <template #rightHeader >
        <b-button v-if="userData.roles[0] === 'admin'" style="margin-top:27px !important" size="md" variant="outline-primary" class="btn btn-primary mr-1" @click="$router.push({name:`counselings-transfer`})">
            <span class="text-nowrap">{{ $t('counselings.transferCounseling')}}</span>
        </b-button>
      </template> -->
      <!-- Column: status -->
      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`counselings.${item.status}`)"
          :options="statusOptions"
        />
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row
          v-if="isViewable('edit', 'counseling')"
          @click.native="toEditPage(item._id)"
        />
        <!-- <delete-row v-if="isViewable('delete', 'counseling')" @click.native="deleteItem(item._id)" /> -->
        <!--        <view-row :class="item.consultantId && userData.id === item.consultantId._id && item.viewConsultIds.length > 0 || userData.permissions.roleName === 'admin' ? '' : 'eyeColor' "  v-if="isViewable('create', 'counseling')" @click.native="$router.push({name: `pages-counseling-messages`,params: { id: item._id } })" />-->
        <view-row
          v-if="isViewable('create', 'counseling')"
          :class="item.viewConsultIds.includes(userData.id) ? '' : 'eyeColor' "
          @click.native="$router.push({name: `pages-counseling-messages`,params: { id: item._id } })"
        />
      </template>
    </BDataTable>
    <!-- <b-modal
      v-model="showChangeModalBox"
      hide-header-close
      centered
      hide-footer
      hide-header
      body-class="message-modal"
      no-fade
    >
      <div>
        <h3 class="mb-2 px-1">{{$t('counselings.transferTitle')}}</h3>
        <div class="col-12">
          <b-col>
            <b-form-group
                :label="$t('counselings.lastCounseling')"
            >
              <v-select-custom
                :options="userOptions1"
                :customProps="{ label: 'fullName' }"
                v-model="lastConsultantId"
                @open="fetchUsersByRole1({ role: 'consultant' })"
                @search="fetchUsersByRole1({ role: 'consultant', 'search' : $event })"
              />
            </b-form-group>
            <span v-if="counselingChats">تعداد آیتم ها : {{ counselingChats.length }}</span>
          </b-col>
        </div>
        <div class="col-12 mt-3 mb-1 hr-sec px-2">
          <div class="lable-hr">{{ $t('counselings.couselingTo') }}</div>
        </div>
        <div class="col-12">
          <b-col>
            <b-form-group
                :label="$t('counselings.newCounseling')"
            >
              <v-select-custom
                :options="userOptions2"
                :customProps="{ label: 'fullName' }"
                v-model="newConsultantId"
                @open="fetchUsersByRole2({ role: 'consultant' })"
                @search="fetchUsersByRole2({ role: 'consultant', 'search' : $event })"
              />
            </b-form-group>
          </b-col>
        </div>
         <div class="col-12">
          <b-col>
            <b-button style="margin-top:27px !important" size="md" variant="outline-primary" class="btn btn-primary mr-1" @click="transferCounselings">
                <span class="text-nowrap">{{ $t('counselings.transferCounseling')}}</span>
            </b-button>
          </b-col>
        </div>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import {
  BCol, BFormGroup,
} from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import ViewRow from '@/components/BDataTable/Actions/ViewRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import '@core/components/toastification/ToastificationContent.vue'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import useCounselingsList from './useCounselingsList'

export default {
  name: 'CounselingList',
  components: {
    BCol,
    BDataTable,
    BFormGroup,
    EditRow,
    LayoutLoading,
    PillIconCell,
    VSelectCustom,
    ViewRow,
  },
  setup() {
    const {
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
      userOptions1,
      userOptions2,
      fetchUsersByRole,
      fetchUsersByRole1,
      fetchUsersByRole2,
      isViewable,
      fetchCounseling1,
      counseling1,
      transferCounseling,
    } = useCounselingsList()
    return {
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
      userOptions1,
      userOptions2,
      fetchUsersByRole,
      fetchUsersByRole1,
      fetchUsersByRole2,
      isViewable,
      fetchCounseling1,
      counseling1,
      transferCounseling,
    }
  },
  data() {
    return {
      consultantOptions: [],
      consultantId: null,
      lastConsultantId: null,
      newConsultantId: null,
      consultantChatIds: null,
      showChangeModalBox: false,
      counselingChats: [],
      userId: null,
      userData: getUserData() || {},
    }
  },
  computed: {
    filters() {
      return {
        consultantId: this.consultantId && this.consultantId._id,
        userId: this.userId && this.userId._id,
      }
    },
  },
  watch: {
    consultantId() {
      this.refTable.refetchData()
    },
    userId() {
      this.refTable.refetchData()
    },
    lastConsultantId(newData) {
      this.fetchCounseling1(newData._id).then(res => {
        this.counselingChats = res.data
      })
    },
  },
  created() {
    this.fetchUsersByRole({
      role: 'consultant',
    }).then(res => {
      this.consultantOptions = res
    })
    this.fetchUsersByRole({
      role: 'user',
    }).then(res => {
      this.userOptions = res
    })
  },
  methods: {
    searchConsultant(search) {
      this.fetchUsersByRole({
        role: 'consultant',
        search,
      }).then(res => {
        this.userOptions = res
      })
    },
    searchUser(search) {
      this.fetchUsersByRole({
        role: 'user',
        search,
      }).then(res => {
        this.userOptions = res
      })
    },
    showChangeModal() {
      this.showChangeModalBox = !this.showChangeModalBox
    },
    // transferCounselings(){
    //   var payload = {
    //     ids: [],
    //     consultantId: ''
    //   }
    //   var variant = 'primary'
    //   var timeout = 4000
    //   for(let i = 0;i <this.counselingChats.length;i++){
    //     payload.ids.push(this.counselingChats[i]._id)
    //   }
    //   payload.consultantId = this.newConsultantId._id
    //   this.transferCounseling(payload).then(res => {
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: 'انتقال مشاوره',
    //         icon: 'BellIcon',
    //         text: 'عملیات با موفقیت انجام شد',
    //         variant,
    //       },
    //     },
    //     {
    //       timeout,
    //     })
    //   })
    //   this.showChangeModalBox = !this.showChangeModalBox
    // }
  },
}
</script>
<style scoped>
.eyeColor{
  fill: #6ad38c !important;
  opacity: 1 ;
}
.hr-sec{
  border-top:1px solid #e3e3e3;
  position: relative;
  text-align: center;
}
.lable-hr{
  position: relative;
  background: #fff;
  margin: 0 auto;
  display: inline-block;
  padding: 5px 15px;
  top:-17px;
}
@media (max-width : 1199px){
  .feather-edit{
    margin-bottom: 20px;
    margin-right: 1rem !important;

}
}
</style>
